// PluginContract_CaptionNode.ts
export const CaptionNodeContract = {
  pluginName: 'CaptionPlugin',
  nodeTypes: ['CaptionNode'],
  register: (editor: any) => {
    // If CaptionNode is custom, ensure it's registered
    editor.registerNodeType?.('CaptionNode');
    console.log('🔌 [CaptionPlugin] Registered CaptionNode');
  },
};